/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Data_Export_TitleInputs */

const en_settings_data_export_title = /** @type {(inputs: Settings_Data_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Your Data`)
};

const de_settings_data_export_title = /** @type {(inputs: Settings_Data_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daten exportieren`)
};

const fr_settings_data_export_title = /** @type {(inputs: Settings_Data_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter vos donnees`)
};

const es_settings_data_export_title = /** @type {(inputs: Settings_Data_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar tus datos`)
};

const it_settings_data_export_title = /** @type {(inputs: Settings_Data_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta i tuoi dati`)
};

const nl_settings_data_export_title = /** @type {(inputs: Settings_Data_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegevens exporteren`)
};

const pl_settings_data_export_title = /** @type {(inputs: Settings_Data_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksportuj swoje dane`)
};

const fi_settings_data_export_title = /** @type {(inputs: Settings_Data_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vie tietosi`)
};

const da_settings_data_export_title = /** @type {(inputs: Settings_Data_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksporter dine data`)
};

const sv_settings_data_export_title = /** @type {(inputs: Settings_Data_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportera dina data`)
};

/**
* | output |
* | --- |
* | "Export Your Data" |
*
* @param {Settings_Data_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_data_export_title = /** @type {((inputs?: Settings_Data_Export_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Data_Export_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_data_export_title(inputs)
	if (locale === "fr") return fr_settings_data_export_title(inputs)
	if (locale === "es") return es_settings_data_export_title(inputs)
	if (locale === "it") return it_settings_data_export_title(inputs)
	if (locale === "nl") return nl_settings_data_export_title(inputs)
	if (locale === "pl") return pl_settings_data_export_title(inputs)
	if (locale === "fi") return fi_settings_data_export_title(inputs)
	if (locale === "da") return da_settings_data_export_title(inputs)
	if (locale === "sv") return sv_settings_data_export_title(inputs)
	return en_settings_data_export_title(inputs)
});